export const LAMBDA_BASE_URL =
  process.env.NODE_ENV === "development"
    ? "http://localhost:3001"
    : "https://7dqktlh5adfa6lphzsmxprnngi0jmuqv.lambda-url.us-east-2.on.aws";
